import React from 'react';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { FooterBar } from './FooterBar';

type View = 'dashboard' | 'analytics' | 'settings';

interface AppLayoutProps {
  currentView: View;
  onViewChange: React.Dispatch<React.SetStateAction<View>>;
  children: React.ReactNode;
}

export const AppLayout: React.FC<AppLayoutProps> = ({
  currentView,
  onViewChange,
  children,
}) => {
  const [sidebarOpen, setSidebarOpen] = React.useState(true);
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 1024);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);
  const sidebarWidth = isMobile ? '0' : sidebarOpen ? '16rem' : '4rem';

  return (
    <div 
      className="flex min-h-screen text-white" 
      style={{ backgroundColor: '#1a1a1f' }}
    >
      <Sidebar 
        currentView={currentView} 
        onViewChange={onViewChange}
        isOpen={sidebarOpen}
        onToggle={toggleSidebar}
        isMobile={isMobile}
      />
      {isMobile && sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-40 lg:hidden"
          onClick={toggleSidebar}
        />
      )}
      <div 
        className="flex-1 flex flex-col transition-all duration-300" 
        style={{ 
          marginLeft: sidebarWidth,
          backgroundColor: '#1a1a1f'
        }}
      >
        <Topbar
          isMobile={isMobile}
          sidebarOpen={sidebarOpen}
          onToggleSidebar={toggleSidebar}
        />
        <main 
          className="flex-1 overflow-auto" 
          style={{ backgroundColor: '#1a1a1f' }}
        >
          {children}
        </main>
        <FooterBar />
      </div>
    </div>
  );
};

